import { useRouter } from "next/router";
import { ADMIN_INDEX, BROKER_INDEX } from "./links";

export enum AppMode {
  ADMIN = "Admin",
  BRAND = "Brand",
  BROKER = "Broker",
}

export function getAppModeForPath(path: string): AppMode {
  if (path.startsWith(ADMIN_INDEX)) return AppMode.ADMIN;
  if (path.startsWith(BROKER_INDEX)) return AppMode.BROKER;
  return AppMode.BRAND;
}

export function useAppMode(): AppMode {
  const { pathname } = useRouter();
  return getAppModeForPath(pathname);
}
